import React from "react";
import PropTypes from "prop-types";
import InputWrapper from "../InputWrapper";
import style from "../../../assets/css/styles.module.scss";

const Select = ({
  className,
  isValid,
  errorMsg,
  id,
  selectOptions,
  placeholder,
  defaultValue,
  onChange,
  options,
  value,
  name,
  label,
  afterInputText
}) => {
  const uncontrolledOptions = defaultValue ? { defaultValue } : {};
  const controlledOptions = value !== null ? { value, onChange } : {};

  return (
    <InputWrapper
      className={className}
      isValid={isValid}
      errorMsg={errorMsg}
      label={label}
      afterInputText={afterInputText}
    >
      <select
        id={id}
        name={name}
        {...options}
        {...controlledOptions}
        placeholder={placeholder}
        {...uncontrolledOptions}
        className={isValid === false ? style.inputError : ""}
      >
        {placeholder && (
          <option key="placeholder" value={null}>
            {placeholder}
          </option>
        )}
        {selectOptions &&
          selectOptions.map(option => {
            const showOption = option.name ? option : {};
            if (option.value == null || option.name == null) {
              showOption.value = option;
              showOption.name = option;
            }
            return (
              <option key={`select_${showOption.value}`} value={showOption.value}>
                {showOption.value}
              </option>
            );
          })}
      </select>
    </InputWrapper>
  );
};

Select.displayName = "Select";

Select.defaultProps = {
  id: "",
  name: "",
  defaultValue: null,
  errorMsg: null,
  onChange: () => {},
  placeholder: null,
  className: null,
  value: null,
  options: null,
  isValid: null,
  label: null,
  afterInputText: null
};

Select.propTypes = {
  /** Select id */
  id: PropTypes.string,
  /** Select name */
  name: PropTypes.string,
  /** Add any html attributes to the component */
  options: PropTypes.object,
  /** Change event callback */
  onChange: PropTypes.func,
  /** Select value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Select default value */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Select validation error message */
  errorMsg: PropTypes.string,
  /** Select placeHolder */
  placeholder: PropTypes.string,
  /** Add className to the component */
  className: PropTypes.string,
  /** Is Select valid */
  isValid: PropTypes.bool,
  /** Options of Select */
  selectOptions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({ value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), name: PropTypes.string }),
      PropTypes.string
    ])
  ).isRequired,
  /** If provided, will add label before the input */
  label: PropTypes.string,
  /** If provided, will add text after the input */
  afterInputText: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Select;
